import React from "react";
import { Alert, Box, Button, CircularProgress, Typography } from "@mui/material";
import { ONBOARDING_ACTION_ROW_LIMIT } from "../../../helper/onboardingActions";

const STATUS_LABELS = {
  queued: "Queued",
  submitting: "Starting…",
  pending: "Starting…",
  running: "Running",
  completed: "Done",
  failed: "Failed",
  cancelled: "Cancelled",
  not_started: "Not started",
};

const ACTIVE = ["submitting", "pending", "running"];

/** Progress for the wizard actions running on a freshly created saved search. */
export default function OnboardingActionsBanner({ run, onDismiss }) {
  if (!run) return null;
  const { items, error, finished } = run;
  const title = finished
    ? "Your onboarding actions finished"
    : `Running your onboarding actions on the first ${ONBOARDING_ACTION_ROW_LIMIT} companies`;

  return (
    <Box
      data-testid="onboarding-actions-banner"
      role="status"
      sx={{
        mb: 2,
        p: { xs: 1.5, md: 2 },
        borderRadius: "14px",
        border: "1px solid rgba(88, 89, 91, 0.12)",
        bgcolor: "background.paper",
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "space-between" }}>
        <Typography component="h2" sx={{ fontSize: { xs: 14, md: 15 }, fontWeight: 700 }}>
          {title}
        </Typography>
        {finished ? (
          <Button size="small" onClick={onDismiss}>
            Dismiss
          </Button>
        ) : null}
      </Box>
      {items.length > 0 ? (
        <Box component="ul" sx={{ m: 0, p: 0, listStyle: "none", display: "flex", flexWrap: "wrap", gap: 1 }}>
          {items.map((item) => (
            <Box
              component="li"
              key={item.id}
              data-testid={`onboarding-action-${item.id}`}
              data-status={item.status}
              sx={{ display: "flex", alignItems: "center", gap: 0.75, fontSize: 13 }}
            >
              {ACTIVE.includes(item.status) ? <CircularProgress size={12} /> : null}
              <span>{item.label}</span>
              <Typography component="span" sx={{ fontSize: 12, color: "text.secondary" }}>
                {STATUS_LABELS[item.status] || item.status}
              </Typography>
            </Box>
          ))}
        </Box>
      ) : null}
      {error ? <Alert severity="warning">{error}</Alert> : null}
    </Box>
  );
}
